<template>
  <div id="admin-reports">
    <vx-card>
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <h4 class="mb-8">Ankiety ewaluacyjne</h4>
          </b-col>
          <b-col>
            <p>Wybierz przedział czasowy</p>
            <date-picker v-model="questionnaireTime" valueType="format" placeholder="Od początku" range></date-picker>
          </b-col>
          <b-col>
            <p>Wybierz ankietę:</p>

            <vs-select placeholder="Wszystkie" v-model="select" width="100%">
              <vs-select-item v-for="option in options" :option="option" :key="option.uuid" :text="option.name" :value="option.uuid">
              </vs-select-item>
            </vs-select>
          </b-col>
          <b-col class="mb-3" cols="12">
            <vs-button :disabled="select" type="filled round" class="float-right  mt-8" icon-pack="feather" icon="icon-download"
                       @click="getQuestionnairesXls">Pobierz .xls
            </vs-button>
            <vs-button type="filled round" class="float-right  mt-8 mr-5" icon-pack="feather" icon="icon-download"
                       @click="getQuestionnairesPdf">Pobierz .pdf
            </vs-button>
          </b-col>
        </b-row>
      </b-container>
    </vx-card>
    <vx-card class="mt-8">
      <b-container fluid>
        <b-row>
          <b-col>
            <h4 class="mb-8">Statystyki</h4>
            <p>Wybierz przedział czasowy</p>
            <date-picker v-model="reportTime" valueType="format" placeholder="Od początku" range></date-picker>
          </b-col>
          <b-col class="mb-3" cols="12">
            <vs-button type="filled round" class="float-right mt-8" icon-pack="feather" icon="icon-download"
                       @click="getReport">Pobierz .xls
            </vs-button>
            <vs-button type="filled round" class="float-right mt-8 mr-5" icon-pack="feather" icon="icon-download"
                       @click="getReportPdf">Pobierz .pdf
            </vs-button>
          </b-col>
        </b-row>
      </b-container>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios"
import notification from "@/notification"
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pl'

export default {
  name: "Reports.vue",
  components: {DatePicker},
  data () {
    return {
      questionnaireTime: null,
      reportTime: null,
      select: null,
      options: null,
    }
  },
  mounted() {
    axios.get('/cp/questionnaires', )
      .then(response => {
        if (response.status === 200) {
          this.options = [{uuid: null, name: "Wszystkie"}, ...response.data];
        } else {
          this.$vs.notify(notification.error('Błąd przy wyświetlaniu ankiet'))
        }
      })
      .catch(error => {
        this.$vs.notify(notification.error(error.message))
      })
  },
  methods: {
    getQuestionnairesXls () {
      let fromDate = '2021-01-01'
      let toDate = null
      if (this.questionnaireTime && this.questionnaireTime[0] && this.questionnaireTime[1]) {
        fromDate = this.questionnaireTime[0]
        toDate = this.questionnaireTime[1]
      }
      axios.get('/cp/questionnaire/xls', {params: {fromDate, toDate}, responseType: 'arraybuffer'})
        .then(response => {
          if (response.status === 200) {
            this.downloadFile(response, false)
          } else {
            this.$vs.notify(notification.error('No file found'))
          }
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    getQuestionnairesPdf () {
      let fromDate = '2021-01-01'
      let toDate = null
      let questionnaire = this.select
      if (this.questionnaireTime && this.questionnaireTime[0] && this.questionnaireTime[1]) {
        fromDate = this.questionnaireTime[0]
        toDate = this.questionnaireTime[1]
      }
      axios.get('/cp/questionnaire/pdf', {params: {fromDate, toDate, questionnaire}, responseType: 'arraybuffer'})
        .then(response => {
          if (response.status === 200) {
            this.downloadFile(response, true)
          } else {
            this.$vs.notify(notification.error('No file found'))
          }
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    getReport () {
      let fromDate = '2021-01-01'
      let toDate = null
      if (this.reportTime && this.reportTime[0] && this.reportTime[1]) {
        fromDate = this.reportTime[0];
        toDate = this.reportTime[1];
      }
      axios.get(`/cp/reports/xls`, {params: {fromDate, toDate}, responseType: 'arraybuffer'})
        .then(response => {
          if (response.status === 200) {
            this.downloadFile(response,false)
          } else {
            this.$vs.notify(notification.error('No file found'))
          }
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    getReportPdf() {
      let fromDate = '2021-01-01';
      let toDate = null;
      if(this.reportTime && this.reportTime[0] && this.reportTime[1]) {
        fromDate = this.reportTime[0];
        toDate = this.reportTime[1];
      }
      axios.get('/cp/reports/pdf', {params: {fromDate, toDate}, responseType: 'arraybuffer'})
        .then(response => {
          if (response.status === 200) {
            this.downloadFile(response, true)
          } else {
            this.$vs.notify(notification.error('No file found'))
          }
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
    },
    downloadFile(response, pdf) {
      const headerLine = response.headers['content-disposition']
      const startFileNameIndex = headerLine.indexOf('=') + (pdf ? 2 : 1)
      const endFileNameIndex = headerLine.length - (pdf ? 1 : 0)
      const filename = headerLine.substring(startFileNameIndex, endFileNameIndex)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    }
  },
}
</script>

<style lang="scss">
</style>
